import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { initializeForm } from '../../../utils/form';
import { ADDITIONAL_PARTICIPANT_EVENTS } from '../../../event_bus_modules/additional_participant';
import { validateEmail, validateNotEmpty, validateValueNotTaken } from '../../../utils/validators';

$(() => {
  const shareholderFormCheckBox = $('#checkbox-no-shareholder');
  const shareholderFormContainer = $('#shareholder-container');
  const shareholderFormHeader = $("p[name='shareholder-container-header']");
  const formIsRequired = shareholderFormHeader.hasClass('required');
  const primaryPurchaserEmail = $('input#_primary_purchaser_email').val();

  if (shareholderFormCheckBox.val() === 'myself') {
    shareholderFormCheckBox.prop('checked', true);
  }

  const onShareholderCheckboxChange = () => {
    if (shareholderFormCheckBox.prop('checked')) {
      shareholderFormCheckBox.val('myself');
      if (formIsRequired) {
        EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.SHAREHOLDER,
        });
      }
    } else {
      shareholderFormCheckBox.val('additional-owner');
      if (formIsRequired) {
        EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.ADD_ERROR, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.SHAREHOLDER,
        });
        shareholderForm.restart();
      }
    }
  };

  if (shareholderFormCheckBox.prop('checked')) {
    shareholderFormCheckBox.val('myself');
  }

  const shareholderForm = initializeForm(shareholderFormContainer, {
    preventDefault: true,
    validate: (values) => {
      let addedShareholdersNumber = shareholderFormContainer.find(
        '.additional-participant__added-person-row'
      ).length;

      const errors = {
        ...validateEmail(values, 'email'),
        ...validateNotEmpty(values, ['first-name', 'last-name']),
        ...validateValueNotTaken(values, 'email', {
          valuesTaken: [primaryPurchaserEmail],
        }),
      };

      let hasErrors = false;
      if (!shareholderFormCheckBox.prop('checked') && formIsRequired) {
        hasErrors = addedShareholdersNumber == 0 ? true : false;
      }

      const eventType = hasErrors
        ? ADDITIONAL_DETAILS_EVENTS.ADD_ERROR
        : ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR;

      EVENT_BUS.dispatch(eventType, {
        error: ADDITIONAL_DETAILS_EVENTS.ERROR.SHAREHOLDER,
      });

      return errors;
    },
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_NEW_PARTICIPANT, () => {
    if (shareholderForm) {
      shareholderForm.restart();
    }
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.REMOVED_PARTICIPANT, () => {
    if (shareholderForm) {
      shareholderForm.restart();
    }
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_SELECTED_PARTICIPANT, () => {
    if (shareholderForm) {
      shareholderForm.restart();
    }
  });

  shareholderFormCheckBox.on('change', onShareholderCheckboxChange);
});
